import axios from 'axios';

// Replace the base URL with your Render backend URL
const BASE_URL = 'https://urlshortener-serverside.onrender.com/api';

// Global error handler
const handleError = (error) => {
  console.error('API Error:', error.response?.data || error.message);
  throw error;
};

// Fetch shortened links
export const fetchShortenedLinks = async (creator = '', options = {}) => {
  try {
      const params = { sort: 'desc' };
      const compact = options.compact !== false;
      if (compact) params.compact = 1;
      const limit = Number(options.limit);
      params.limit = Number.isFinite(limit) && limit > 0 ? Math.floor(limit) : 50;
      if (creator) params.creator = creator;
      const response = await axios.get(`${BASE_URL}/links`, {
          params, // Fetch links in descending order
      });
      return response.data;
  } catch (error) {
      console.error('API Error:', error.response?.data || error.message);
      throw error;
  }
};



// Fetch total link clicks over time
export const fetchTotalLinkClicksOverTime = async (linkId) => {
  try {
    const response = await axios.get(`${BASE_URL}/chart1`, { params: { linkId } });
    return response.data.totalLinkClicksOverTime;
  } catch (error) {
    handleError(error);
  }
};

// Shorten a URL
export const shortenUrl = async (longUrl, creator = '', customAlias = '') => {
  try {
    const payload = { longUrl, creator };
    if (customAlias?.trim()) payload.customAlias = customAlias.trim();
    const response = await axios.post(`${BASE_URL}/links/shorten`, payload);
    return response.data.shortUrl;
  } catch (error) {
    handleError(error);
  }
};
